import { Map } from 'immutable'
import {
  SET_ROLES_PROCESSING,
  SET_ROLES_ERROR,
  SET_ROLES_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_ROLES_PROCESSING:
      return state.set('processing', payload.processing)
    case SET_ROLES_DATA:
      return state
        .set('data', payload.data)
        .set('processing', payload.processing)
    case SET_ROLES_ERROR:
      return state
        .set('error', payload.error)
        .set('processing', payload.processing)
    default:
      return state
  }
}
